import React from "react";
import {
  InputAdornment,
  StandardTextFieldProps,
  styled,
  TextField,
} from "@mui/material";

export interface SearchFieldInterface extends StandardTextFieldProps {
  placeholder?: string;
  searchIconPosition?: "end" | "start";
  isLight?: boolean;
  height?: number;
  fontSize?: number;
}

const StyledTextField = styled(TextField, {
  shouldForwardProp: (prop) => prop !== "isLight" && prop !== "height" && prop !== "fontSize",
  name: "Serach",
})<{ isLight?: boolean; height?: number; fontSize?: number; theme?: any }>(
  ({ isLight, height, fontSize, theme }) => ({
    backdropFilter: isLight ? "blur(3px)" : undefined,
    backgroundColor: isLight ? "rgba(255, 255, 255, 0.25)" : undefined,
    height: height || 50,
    padding: "0px 15px",
    "& .MuiInput-root": {
      height: "100%",
      justifyContent: "center",
      fontSize: fontSize || 16
    },
    "& .MuiInput-input": {
      "-webkit-text-fill-color": isLight ? `${theme.palette.common.white} !important` : `${theme.palette.common.black} !important`,
      padding: 0,
    },
    '& .MuiInputAdornment-root': {
      color: isLight ? "rgba(255, 255, 255, 0.47)" : "rgba(18, 18, 18, 0.5)",
      backgroundColor: "transparent"
    }
  }),
);

const SearchField = ({ placeholder = "Search", searchIconPosition, isLight, height, fontSize, ...props }: SearchFieldInterface) => {
  return (
    <StyledTextField  {...props} isLight={isLight} height={height} variant="standard" fontSize={fontSize} placeholder={placeholder} InputProps={{
      disableUnderline: true,
      endAdornment: searchIconPosition && searchIconPosition === "end" ? <InputAdornment position="end">
        <i className="far fa-search"></i>
      </InputAdornment> : null,
      startAdornment: searchIconPosition && searchIconPosition === "start" ? <InputAdornment position="start">
        <i className="far fa-search"></i>
      </InputAdornment> : null,
      autoComplete: "off",
    }} />
  )
}

export default SearchField;
